import { render } from "./P020.vue?vue&type=template&id=3ebbecbb&scoped=true"
import script from "./P020.vue?vue&type=script&lang=js"
export * from "./P020.vue?vue&type=script&lang=js"

import "./P020.vue?vue&type=style&index=0&id=3ebbecbb&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebbecbb"]])

export default __exports__